module.exports = __webpack_public_path__ + "assets/no-results.fc903958.svg";